import React from "react";
// import { Link } from "react-router-dom";
import { Nav, Navbar } from 'react-bootstrap';
// import NavDropdown from 'react-bootstrap/NavDropdown';
import "bootstrap/dist/css/bootstrap.min.css";

import "./navbars.css";
import logo from "../assets/images/logo.png"

const NavbarTop = ({
  APPDATA,
  routes
  // currentUser,
}) => {

  return (

    <Navbar sticky="top" expand="sm" className="bg-body-tertiary nav-container" collapseOnSelect={true} >
      <Navbar.Brand href="#" className="nav-brand" title={`${APPDATA.TITLE} (Ver: ${APPDATA.VER} ${APPDATA.MODE})`}><img className="nav-logo" alt="logo" src={logo}        // src={APPDATA.LOGO}
      />{APPDATA.TITLE}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          {routes.map(r => {
            return <Nav.Link key={r.route} href={r.path}>{r.route}</Nav.Link>
          })}

          {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown> */}
        </Nav>
      </Navbar.Collapse>

    </Navbar >

  );
};

export default NavbarTop;





